export default __webpack_public_path__ + "static/media/univerity_of_oregon_o.f6c5eda3.svg";